import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { FiTaskReportStatusType } from '@fi-app/task-v2/fi-task-v2-report/fi-task-v2-report-enums';

@Component({
    selector: 'fi-task-v2-report-status-badge',
    templateUrl: './fi-task-v2-report-status-badge.component.html',
    styleUrl: '../../../shared/fi-progress-badge/fi-progress-badge.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-report-status-badge' },
    standalone: false,
})
export class FiTaskV2ReportStatusBadgeComponent {
    public taskReportStatus = input.required<FiTaskReportStatusType>();
    protected reportStatusTextId = computed(() => this.taskReportStatusLabels[this.taskReportStatus()] || '');
    protected reportStatusClass = computed(() => this.taskReportStatusClasses[this.taskReportStatus()] || '');

    private readonly taskReportStatusLabels = {
        [FiTaskReportStatusType.NotStarted]: 'checklist.not_started',
        [FiTaskReportStatusType.InProgress]: 'taskv2.in_progress',
        [FiTaskReportStatusType.Completed]: 'common.completed',
        [FiTaskReportStatusType.Overdue]: 'task.overdue',
        [FiTaskReportStatusType.Cancelled]: 'common.cancelled',
    } as const;

    private readonly taskReportStatusClasses = {
        [FiTaskReportStatusType.NotStarted]: 'fi-progress-badge--not-started',
        [FiTaskReportStatusType.InProgress]: 'fi-progress-badge--in-progress',
        [FiTaskReportStatusType.Completed]: 'fi-progress-badge--completed',
        [FiTaskReportStatusType.Overdue]: 'fi-progress-badge--overdue',
        [FiTaskReportStatusType.Cancelled]: 'fi-progress-badge--cancelled',
    } as const;
}
